import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useI18n } from "../context/I18nContext";

const IMGS = {
  industrial: "https://images.unsplash.com/photo-1776254575132-fbc8f3d50210?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwc2NyYXAlMjBtZXRhbCUyMG1hY2hpbmVyeXxlbnwwfHx8fDE3NzcxODY3MjB8MA&ixlib=rb-4.1.0&q=85",
  machinery: "https://images.unsplash.com/photo-1767989394831-1ca05fe82dc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxydXN0eSUyMGdlYXJzJTIwbWFjaGluZXJ5fGVufDB8fHx8MTc3NzE4NjczNHww&ixlib=rb-4.1.0&q=85",
  electrical: "https://images.pexels.com/photos/28286031/pexels-photo-28286031.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

const POINTS_EN = {
  industrial: ["Iron & MS scrap", "Stainless steel (304/316)", "Aluminium turnings & sheets", "Brass & bronze", "Copper offcuts"],
  machinery: ["CNC, VMC & lathes", "Presses, mills & shapers", "Gearboxes & motors", "Compressors & pumps", "Full plant clearance"],
  electrical: ["Copper cables & wires", "Transformers & panels", "Switchgear & busbars", "Industrial electronics", "AC & DG sets"],
};

const POINTS_TA = {
  industrial: ["இரும்பு & MS ஸ்க்ராப்", "ஸ்டெயின்லெஸ் ஸ்டீல் (304/316)", "அலுமினியம் தாள் & துகள்கள்", "பித்தளை & வெண்கலம்", "செம்பு துண்டுகள்"],
  machinery: ["CNC, VMC & லேத்து", "அழுத்தங்கள், மில்கள் & ஷேப்பர்கள்", "கியர்பாக்ஸ் & மோட்டார்கள்", "காம்ப்ரெசர்கள் & பம்புகள்", "முழு தொழிற்சாலை அழிப்பு"],
  electrical: ["செம்பு கேபிள்கள் & கம்பிகள்", "டிரான்ஸ்பார்மர்கள் & பேனல்கள்", "ஸ்விட்ச்கியர் & பஸ்பார்கள்", "தொழில் மின்னணுவியல்", "AC & DG செட்டுகள்"],
};

export default function Services() {
  const { t, lang } = useI18n();
  const points = lang === "ta" ? POINTS_TA : POINTS_EN;

  const items = [
    { key: "industrial", title: t("services.industrial.title"), img: IMGS.industrial, list: points.industrial },
    { key: "machinery", title: t("services.machinery.title"), img: IMGS.machinery, list: points.machinery },
    { key: "electrical", title: t("services.electrical.title"), img: IMGS.electrical, list: points.electrical },
  ];

  return (
    <div data-testid="services-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-12">
        <div className="overline">{t("servicesPage.overline")}</div>
        <h1 className="font-display font-black uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl mt-5 leading-none">
          {t("servicesPage.titleA")} <span className="text-[#00A896]">{t("servicesPage.titleB")}</span>
        </h1>
        <p className="text-[#8C939D] max-w-2xl mt-6 leading-relaxed">{t("servicesPage.intro")}</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24 space-y-6">
        {items.map((s, i) => (
          <div
            key={s.key}
            className={`brut-card grid grid-cols-1 lg:grid-cols-2 gap-0 ${i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""}`}
            data-testid={`service-detail-${s.key}`}
          >
            <div className="aspect-[4/3] lg:aspect-auto overflow-hidden">
              <img src={s.img} alt={s.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <div className="overline text-[#8C939D]">/// 0{i + 1}</div>
              <h2 className="font-display font-bold text-3xl sm:text-4xl uppercase tracking-tight mt-4 text-white">{s.title}</h2>
              <ul className="mt-6 space-y-3">
                {s.list.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-[#C7CBD3] text-sm">
                    <CheckCircle2 size={18} className="text-[#00A896] mt-0.5 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="btn-outline mt-8 self-start text-xs">
                {t("servicesPage.getQuote")} <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
